export default {
	//邮箱注册接口
	sendEmailVerificationCode:'/conference/user/sendEmailVerificationCode',
	queryVerifyCodeOfEmail:'/conference/user/queryVerifyCodeOfEmail',
	emailRegister:'/conference/user/emailRegister',
	//用户信息接口
	getCrUserInfo:'/conference/userinfo/getCrUserInfo',
	upDataUserInfo:'/conference/userinfo/upDataUserInfo',
	queryOrgNameByOrfCode:'/conference/organ/queryOrgNameByOrfCode',
	//手机注册
	sendPhoneVerificationCode:'/conference/user/sendPhoneVerificationCode',
	phoneRegister:'/conference/user/phoneRegister',
	loginByVerificationCode:'/conference/user/loginByVerificationCode',
	modifyPassword:'/conference/user/modifyPassword',
	//修改手机邮箱
	bindingForPhone:'/conference/user/bindingForPhone',
	CrBindEmailReq:'/conference/user/CrBindEmailReq',
	//登录接口
	loginByPassword:'/conference/user/loginByPassword',
	loginByVerificationCodeOfPhone:'/conference/user/loginByVerificationCodeOfPhone',
	loginByPasswordForAdmin:'/conference/user/loginByPasswordForAdmin',
	// 退出登录
	logOut: '/conference/user/loginOut',

	//找回密码
	retrievePasswordByEmail:'/conference/user/retrievePasswordByEmail',
	retrievePasswordByPhone:'/conference/user/retrievePasswordByPhone',
}